// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"312":"2adbf676","1331":"8449c68f","1593":"6ba056f9","1812":"8742717b","2595":"2adbf676","2830":"8449c68f","6394":"6eb789ff","8719":"c8548b8a"}[chunkId] + ".chunk.css";
};